import { ICity } from './../shared/model/address.model';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CitySearch } from '../cities/city.model';
import { logRequest } from '../shared/http-utils';

@Injectable({
    providedIn: 'root',
})
export class CityService {
    baseUrl = '/school-service/api/cities';

    constructor(private http: HttpClient) {}

    getCities(): Observable<ICity[]> {
        return this.http.get<ICity[]>(this.baseUrl);
    }

    deleteCity(city: ICity): Observable<HttpResponse<any>> {
        return this.http.delete(`${this.baseUrl}/${city.id}`, { observe: 'response', headers: logRequest() });
    }

    createCity(city: ICity): Observable<HttpResponse<ICity>> {
        return this.http.post<ICity>(this.baseUrl, city, { observe: 'response', headers: logRequest() });
    }

    updateCity(city: ICity): Observable<HttpResponse<ICity>> {
        return this.http.put<ICity>(this.baseUrl, city, { observe: 'response', headers: logRequest() });
    }

    searchCities(search: CitySearch): Observable<HttpResponse<ICity[]>> {
        return this.http.post<ICity[]>(`${this.baseUrl}/search`, search, { observe: 'response' });
    }

    getCitiesForAutocomplete(searchDTO: CitySearch): Observable<HttpResponse<ICity[]>> {
        return this.http.post<ICity[]>(`${this.baseUrl}/autocomplete`, searchDTO, { observe: 'response' });
    }
}
